import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, BookOpenIcon, ClockIcon, SparklesIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function HowItWorksSection() {
  const steps = [{
    num: 1,
    title: 'Descargas tu ebook y bonos inmediatamente después de comprar.',
    icon: DownloadIcon
  }, {
    num: 2,
    title: 'Lees el plan simple de 30 días.',
    icon: BookOpenIcon
  }, {
    num: 3,
    title: 'Aplicas el método en solo 10 minutos al día.',
    icon: ClockIcon
  }, {
    num: 4,
    title: 'Empiezas a sentir más orden, menos caos y más control en tu vida.',
    icon: SparklesIcon
  }];
  return <section className="py-20 bg-white md:py-32" data-id="element-56">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8" data-id="element-57">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="max-w-4xl mx-auto" data-id="element-58">
          <motion.h2 variants={itemVariants} className="mb-16 text-3xl font-bold text-center md:text-4xl text-charcoal font-playfair" data-id="element-59">
            Cómo funciona este sistema
          </motion.h2>

          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4" data-id="element-60">
            {steps.map((step, index) => <motion.div key={index} variants={itemVariants} className="relative flex flex-col items-center p-8 text-center bg-beige-warm rounded-3xl border border-sage-light/20 shadow-sm" data-id="element-61">
                <div className="absolute top-0 flex items-center justify-center w-10 h-10 font-bold text-white transform -translate-y-1/2 rounded-full bg-sage shadow-md" data-id="element-62">
                  {step.num}
                </div>
                <div className="flex items-center justify-center w-16 h-16 mb-6 rounded-2xl bg-white text-sage shadow-sm" data-id="element-63">
                  <step.icon className="w-8 h-8" data-id="element-64" />
                </div>
                <p className="text-lg font-medium leading-relaxed text-charcoal/90" data-id="element-65">
                  {step.title}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}